module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Bold-webfont.eot
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.eot
// module chunks = styles